<template>
  <div>
    <table class="table is-hoverable is-fullwidth">
      <thead>
        <tr>
          <th>
            Elevation Display Name
          </th>
          <th>
            Drawing Highlight File
          </th>
          <th>
            Uploaded On
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="v-centered" 
          v-for="(file, i) in drawingHighlight.files"
          :key="i">
          <td>
            {{ file.elevation ? file.elevation : '' }}
          </td>
          <td>
            <a 
              :href="file.image"
              target="_blank">
              <span v-if="file.filename">
                {{ file.filename }}
              </span>
              <span v-else>
                drawing highlight file link
              </span>
            </a>
          </td>
          <td>
            {{ formatDate(parseDate(file.created_on)) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { parseJSON, format } from 'date-fns'

export default {
  props: {
    drawingHighlight: {
      type: Object
    }
  },
  data() {
    return {
      parseDate: (date) => { return date ? parseJSON(date) : date },
      formatDate: (date) => format(date, "yyyy-MM-dd HH:mm:ss")
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>